import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }

import { ref, computed } from 'vue'
import { useUserSessionStore } from '../stores/userSession';
import { RouterLink } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoggedMenu',
  setup(__props) {

const store = useUserSessionStore();
const menu = ref(false);
const items = computed(() => [
    {
        key: 'user-name',
        title: `${store.AppActiveUser?.profile?.name} ${store.AppActiveUser?.profile?.last_name}`,
        tooltip: `ID ${store.AppActiveUser?.account?.id}`,
        icon: 'mdi-account-circle',
    },
    {
        key: 'user-email',
        title: `${store.AppActiveUser?.account?.email}`,
    },
    { key: 'sep-1'},
    {
        key: 'link-logout',
        title: `Logout`,
        tooltip: 'Close current session',
        to: '/logout',
    },
]);

const isUserLoggedIn = computed(() => {
        return store.isUserLoggedIn;
    });

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (isUserLoggedIn.value)
    ? (_openBlock(), _createBlock(_component_v_menu, {
        key: 0,
        modelValue: menu.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event)),
        "close-on-content-click": false,
        location: "bottom"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps({ icon: "mdi-dots-vertical" }, props), null, 16)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_card, { "min-width": "300" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, i) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, { key: i }, {
                      default: _withCtx(() => [
                        (!item.title)
                          ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                          : (_openBlock(), _createBlock(_component_v_tooltip, {
                              key: 1,
                              text: item.tooltip
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_list_item_title, _mergeProps({
                                  title: item.tooltip
                                }, props), {
                                  default: _withCtx(() => [
                                    (item.to)
                                      ? (_openBlock(), _createBlock(_unref(RouterLink), {
                                          key: 0,
                                          to: item.to,
                                          title: item.title
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to", "title"]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_1, [
                                          (item.icon)
                                            ? (_openBlock(), _createBlock(_component_v_avatar, {
                                                key: 0,
                                                color: "gray",
                                                class: "mr-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    icon: item.icon || ''
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" " + _toDisplayString(item.title), 1)
                                        ]))
                                  ]),
                                  _: 2
                                }, 1040, ["title"])
                              ]),
                              _: 2
                            }, 1032, ["text"]))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})